import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=5ca38f32&scoped=true"
import script from "./Zonas.vue?vue&type=script&lang=js"
export * from "./Zonas.vue?vue&type=script&lang=js"
import style0 from "./Zonas.vue?vue&type=style&index=0&id=5ca38f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca38f32",
  null
  
)

export default component.exports